Avatar.theme = Avatar.theme || {};

Avatar.theme.Utilities = function Utilities() {
  function smoothScrollTo(endX, endY, duration) {
    var startX = window.scrollX || window.pageXOffset;
    var startY = window.scrollY || window.pageYOffset;
    var distanceX = endX - startX;
    var distanceY = endY - startY;
    var startTime = new Date().getTime(); // Easing function

    function easeInOutQuart(time, from, distance, transitionDuration) {
      // eslint-disable-next-line no-cond-assign
      if ((time /= transitionDuration / 2) < 1) {
        return distance / 2 * time * time * time * time + from;
      } // eslint-disable-next-line no-return-assign


      return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
    }

    var timer = window.setInterval(function () {
      var time = new Date().getTime() - startTime;
      var newX = easeInOutQuart(time, startX, distanceX, duration);
      var newY = easeInOutQuart(time, startY, distanceY, duration);

      if (time >= duration) {
        window.clearInterval(timer);
      }

      window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
  } // Required functionality from depricated options_selection.js


  function arrayIncludes(e, t) {
    for (var n = 0; n < e.length; n++) {
      if (e[n] === t) return !0;
    }

    return !1;
  }

  function uniq(e) {
    for (var t = [], n = 0; n < e.length; n++) {
      arrayIncludes(t, e[n]) || t.push(e[n]);
    }

    return t;
  }

  return {
    smoothScrollTo: smoothScrollTo,
    uniq: uniq
  };
}();